export const TOAST_TYPES = {
  Error: 'error',
  Success: 'success',
  Info: 'info',
  Warning: 'warning'
}